<template>
    <!--    <div class="v-modals">-->
    <LayoutModal v-model="isOpen">
        <component
            :is="modalToShow"
            :modalData="modal"
            :showXButton="modal?.showXButton"
            @close="handleClose()"
        />
    </LayoutModal>
    <!--    </div>-->
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { LayoutModal } from "@easy/ui/layouts";
import PreviewNotFound from "@/views/preview/PreviewNotFound.vue";
import cTrialModal from "@/shared/components/modals/cTrialModal.vue";
import cInfoModal from "@/shared/components/modals/cInfoModal.vue";
import cCodeModal from "@/shared/components/modals/cCodeModal.vue";
import cSuccessModal from "@/shared/components/modals/cSuccessModal.vue";
import cLinkModal from "@/shared/components/modals/cLinkModal.vue";
import cConfirmModal from "@/shared/components/modals/cConfirmModal.vue";
import cInputModal from "@/shared/components/modals/cInputModal.vue";
import TemplateModal from "@/apps/banner/project/modal/TemplateModal.vue";

const MODAL_LIST = {
    trial: cTrialModal,
    info: cInfoModal,
    code: cCodeModal,
    success: cSuccessModal,
    link: cLinkModal,
    confirm: cConfirmModal,
    input: cInputModal,
    template: TemplateModal,
};

export default {
    name: "vModalLayouts",
    components: {
        LayoutModal,
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        ...mapState(["modal"]),
        modalType() {
            return this.modal.type;
        },
        modalToShow() {
            return MODAL_LIST[this.modalType] || PreviewNotFound;
        },
    },
    methods: {
        ...mapMutations(["closeModal"]),
        handleClose() {
            this.isOpen = false;
            setTimeout(this.closeModal, 300);
        },
    },
    watch: {
        modal: {
            handler(modalData) {
                this.isOpen = Boolean(modalData?.type);
            },
            deep: true,
        },
    },
};
</script>
